// extracted by mini-css-extract-plugin
module.exports = {"cart_product_wrapper":"cartProducts_cart_product_wrapper__8OKjt"};